import { useEffect, useState } from "react";
import {
    UserOutlined, LoadingOutlined, LockOutlined
} from '@ant-design/icons';
import { Button, Modal, Spin } from 'antd';


export default function KYCVerificationStep({ data, setData }) {
    const [sellerTerms, setSellerTerms] = useState(false);
    const [returnRefundPolicy, setreturnRefundPolicy] = useState(false);
    const [commissionPolicy, setcommissionPolicy] = useState(false);
    const [checked, setChecked] = useState({
        terms: data?.terms || false,
        commission: data?.commission || false,
        refund: data?.refund || false,
    });

    const handleCheckbox = (e) => {
        const { name, checked: value } = e.target;
        const updated = {
            ...checked,
            [name]: value
        };
        setChecked(updated);
        setData(updated);
         if (value && window.gtag) {
        window.gtag("event", "terms_and_conditions_accepted", {
            event_category: "KYC",
            event_label: "Terms and Conditions Accepted",
        });
    }
    };

    return (
        <div className="container p-0 mt-4">
            <h2 className="h4 mt-5 fw-semibold text-dark mb-0 px-0 pt-0 pb-4" style={{ color: "black", fontSize: "20px", fontWeight: "600" }}>
                Agreement

            </h2>
            <div className="card p-4">
                <h2 className="h4  fw-semibold text-dark mb-0 px-0 pt-0 pb-4 d-flex align-items-center" style={{ color: "black", fontSize: "20px", fontWeight: "600", gap: "5px" }}>
                    <UserOutlined />     Seller Agreement

                </h2>

                <div className="d-flex align-items-center" style={{ gap: "5px", color: "black" }}>
                    <label className=" m-0" >
                        <input
                            type="checkbox"
                            name="terms"
                            checked={checked.terms}
                            onChange={handleCheckbox}


                        />

                    </label>
                    <div className="m-0">
                        I accept the<span style={{ color: "#FB820A", textDecoration: "underline" }} onClick={() => setSellerTerms(true)} > Seller Terms & Conditions</span>
                    </div>
                </div>

                <div className="d-flex align-items-center my-2" style={{ gap: "5px", color: "black" }}>

                    <label className="m-0">
                        <input
                            type="checkbox"
                            name="commission"
                            checked={checked.commission}
                            onChange={handleCheckbox}
                        />

                    </label>
                    <div>
                        I accept the <span style={{ color: "#FB820A", textDecoration: "underline", cursor: "pointer" }} onClick={() => setcommissionPolicy(true)}>Commission Policy</span>
                    </div>

                </div>

                <div className="d-flex align-items-center" style={{ gap: "5px", color: "black" }}>

                    <label className="m-0">
                        <input
                            type="checkbox"
                            name="refund"
                            checked={checked.refund}
                            onChange={handleCheckbox}
                        />

                    </label>

                    <div>
                        I accept the<span style={{ color: "#FB820A", textDecoration: "underline", cursor: "pointer" }} onClick={() => setreturnRefundPolicy(true)}> Return & Refund Policy</span>
                    </div>

                </div>

            </div>

            <Modal

                onCancel={() => setSellerTerms(false)}
                open={sellerTerms}
                footer={null}
                closable={false}
                centered
                width={450}
                style={{ borderRadius: "20px" }}

            >
                <div style={{ textAlign: "center", padding: "20px" }}>
                    <p style={{ fontWeight: "600", fontSize: "20px" }} className="m-0"> To be updated...</p>

                </div>
            </Modal>

            <Modal
                onCancel={() => setcommissionPolicy(false)}
                open={commissionPolicy}
                footer={null}
                closable={false}
                centered
                width={450}
                style={{ borderRadius: "20px" }}

            >
                <div style={{ textAlign: "center", padding: "20px" }}>
                    <p style={{ fontWeight: "600", fontSize: "20px" }} className="m-0"> To be updated...</p>
                </div>
            </Modal>


            <Modal onCancel={() => setreturnRefundPolicy(false)}
                open={returnRefundPolicy}
                footer={null}
                closable={false}
                centered
                width={450}
                style={{ borderRadius: "20px" }}

            >
                <div style={{ textAlign: "center", padding: "20px" }}>
                    <p style={{ fontWeight: "600", fontSize: "20px" }} className="m-0"> To be updated...</p>
                </div>
            </Modal>
        </div>

    );
}
